module.exports = __webpack_public_path__ + "static/img/ourAppImg3.b2fcb039.png";